import { createSlice } from '@reduxjs/toolkit';
import { findAgentTransferLogs } from './api/index';
import { initialState } from './api/interface';

const agentTransferLogsSlice = createSlice({
  name: 'agentTransferLogs',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findAgentTransferLogs.pending, (state) => {
      state.isLoading = true;
      state.status = 'loading';
    });
    builder.addCase(findAgentTransferLogs.fulfilled, (state, action) => {
      state.data = action.payload.data || [];
      state.totalRecords = action.payload.total || 0;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'idle';
    });
    builder.addCase(findAgentTransferLogs.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'idle';
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = agentTransferLogsSlice.actions;
export default agentTransferLogsSlice.reducer;

